/**
 * @generated SignedSource<<856e666e74fea97a2613eb0c395eb666>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeriesPageRealmData$data = {
  readonly ancestors: ReadonlyArray<{
    readonly name: string | null | undefined;
    readonly path: string;
  }>;
  readonly isMainRoot: boolean;
  readonly name: string | null | undefined;
  readonly path: string;
  readonly " $fragmentType": "SeriesPageRealmData";
};
export type SeriesPageRealmData$key = {
  readonly " $data"?: SeriesPageRealmData$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesPageRealmData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeriesPageRealmData",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMainRoot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Realm",
      "kind": "LinkedField",
      "name": "ancestors",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Realm",
  "abstractKey": null
};
})();

(node as any).hash = "9b1a55172a5ec157b96db9ca395f59cd";

export default node;
